import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ChatService } from "../../services/chat.service";
import { SharedService } from '../../services/shared.service';
import { Router } from '@angular/router';
const emails = require('../../services/emails.json');

@Component({
  selector: 'support-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class SupportCardComponent implements OnInit {
  vtuber: any;
  currentSupportPlan: any = undefined;
  currentSupportIndex: number = -1;
  isFailed: boolean = false;
  supportedNum: number = 0;

  constructor(
      public auth: AuthService,
      private shared: SharedService,
      private cs: ChatService,
      private router: Router
    ) {}

  ngOnInit() {
    if (!this.shared.getCookie(SharedService.CURRENT_VTUBER)) {
        this.shared.redirect('/');
        return;
    }

    this.vtuber = JSON.parse(this.shared.getCookie(SharedService.CURRENT_VTUBER));
    this.currentSupportPlan = undefined;

    if (this.auth.user.plans) {
      this.auth.user.plans.map((item, index) => {
        if (item.vtuber_id === this.vtuber.uid) {
          const obj = Object.assign({
            plan: this.vtuber.plans.filter(plan => plan.uid === item.plan_uid)[0]
          }, item)
          this.currentSupportPlan = obj;
          this.currentSupportIndex = index;
        }
      })
    }

    if (this.vtuber.supporters) {
      this.supportedNum = this.vtuber.supporters.filter(item => item.plan_uid === this.vtuber.currentPlan.uid && (item.stoppedAt === undefined || item.stoppedAt > Date.now())).length
    }

    window.scrollTo(0, 0);
  }

  back() {

  }

  canSupport() {
    return this.supportedNum < this.vtuber.currentPlan.limit
  }

  async start() {
    this.isFailed = false
    this.auth.toggleSpinner(true);

    let amount = parseInt(this.vtuber.currentPlan.amount)
    if (this.currentSupportPlan && this.currentSupportPlan.stoppedAt === undefined) { // Change
      amount = amount - parseInt(this.currentSupportPlan.plan.amount)
    }

    if (amount > 0) {
      this.auth.doPay(amount)
      .then((response: any) => {
        response = response.data
        this.doRest(response.id)
      })
      .catch(error => {
        console.log(error);
        this.auth.toggleSpinner(false);
        this.isFailed = true;
      })
    } else if (amount === 0) {
      this.doRest(0);
    } else {
      this.doRest(-1); // No Payment - From High plan to lower plan
    }
  }

  async doRest(payjpPayID) {
    if (this.currentSupportPlan && this.currentSupportPlan.stoppedAt === undefined) { // Change
      let beforePlan = undefined
      this.vtuber.plans.map(item => {
        this.auth.user.plans.map(uitem => {
          if (uitem.vtuber_id === this.vtuber.uid && uitem.plan_uid === item.uid) {
            beforePlan = Object.assign({}, item)
          }
        })
      })

      let currentPlan = Object.assign({}, this.vtuber.currentPlan)
      await this.cs.change(Object.assign({}, this.vtuber), payjpPayID, this.currentSupportIndex)

      if (beforePlan !== undefined) {
        // Sending Email User
        this.auth.sendEmail({
          to: this.auth.user.email,
          subject: emails.support_change_subject.replace(/\[支援先のVTuber名\]/g, this.vtuber.displayName),
          text: this.auth.getEmailTemplate(emails.support_change.join("")).replace(/\[支援先のVTuber名\]/g, this.vtuber.displayName)
                    .replace(/\[変更前の支援プランタイトル\]/g, beforePlan.title)
                    .replace(/\[変更前の支援金額\/月\]/g, beforePlan.amount + '円/月')
                    .replace(/\[変更前の通話時間\/月\]/g, beforePlan.period + "分/月")
                    .replace(/\[変更後の支援プランタイトル\]/g, currentPlan.title)
                    .replace(/\[変更後の支援金額\/月\]/g, currentPlan.amount + '円/月')
                    .replace(/\[変更後の通話時間\/月\]/g, currentPlan.period + "分/月")
                    .replace(/\[ユーザー名\]/g, this.auth.user.displayName)
        })

        // Sending Email Vtuber
        this.auth.sendEmail({
          to: this.vtuber.email,
          subject: emails.support_change_vtuber_subject.replace(/\[支援者のユーザー名\]/g, this.auth.user.displayName),
          text: this.auth.getEmailTemplate(emails.support_change_vtuber.join("")).replace(/\[支援者名\]/g, this.auth.user.displayName)
                    .replace(/\[変更前の支援プランタイトル\]/g, beforePlan.title)
                    .replace(/\[変更前の支援金額\/月\]/g, beforePlan.amount + '円/月')
                    .replace(/\[変更前の通話時間\/月\]/g, beforePlan.period + "分/月")
                    .replace(/\[変更後の支援プランタイトル\]/g, currentPlan.title)
                    .replace(/\[変更後の支援金額\/月\]/g, currentPlan.amount + '円/月')
                    .replace(/\[変更後の通話時間\/月\]/g, currentPlan.period + "分/月")
                    .replace(/\[VTuber名\]/g, this.vtuber.displayName)
        })
      }
    } else {
      if (this.currentSupportPlan) {
        await this.cs.change(Object.assign({}, this.vtuber), payjpPayID, this.currentSupportIndex)
      } else {
        await this.cs.create(Object.assign({}, this.vtuber), payjpPayID);
      }

      // Sending Email User
      this.auth.sendEmail({
        to: this.auth.user.email,
        subject: emails.support_start_subject.replace(/\[支援先のVTuber名\]/g, this.vtuber.displayName),
        text: this.auth.getEmailTemplate(emails.support_start.join("")).replace(/\[支援先のVTuber名\]/g, this.vtuber.displayName)
                  .replace(/\[支援プランタイトル\]/g, this.vtuber.currentPlan.title)
                  .replace(/\[支援金額\/月\]/g, this.vtuber.currentPlan.amount + '円/月')
                  .replace(/\[通話時間\/月\]/g, this.vtuber.currentPlan.period + "分/月")
                  .replace(/\[ユーザー名\]/g, this.auth.user.displayName)
      })

      // Sending Email Vtuber
      this.auth.sendEmail({
        to: this.vtuber.email,
        subject: emails.support_start_vtuber_subject.replace(/\[支援者のユーザー名\]/g, this.auth.user.displayName),
        text: this.auth.getEmailTemplate(emails.support_start_vtuber.join("")).replace(/\[支援者名\]/g, this.auth.user.displayName)
                  .replace(/\[支援プランタイトル\]/g, this.vtuber.currentPlan.title)
                  .replace(/\[支援金額\/月\]/g, this.vtuber.currentPlan.amount + '円/月')
                  .replace(/\[通話時間\/月\]/g, this.vtuber.currentPlan.period + "分/月")
                  .replace(/\[VTuber名\]/g, this.vtuber.displayName)
      })
    }

    this.auth.toggleSpinner(false);

    this.router.navigate(['rooms']);
  }
}
